import { FC } from "react";
import { Icon } from "@livingmap/core-ui-v2";

import Button from "@components/Button/Button";
import ProjectLogo from "@components/ProjectLogo/ProjectLogo";
import Mobile from "@mobile";
import styles from "./NoInternetConnection.module.css";

const NoInternetConnection: FC = () => {
  const handleButtonClick = () => {
    Mobile.sharedSendMessageEmitter("NO_INTERNET_CONNECTION_RETRY", {});
  };

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <Icon type="NoWifiIcon" width={64} />
        <h1 className={styles.text}>No Internet Connection</h1>
        <Button onClick={handleButtonClick}>Try again</Button>
      </div>
      <ProjectLogo />
    </div>
  );
};

export default NoInternetConnection;
